import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 3px 0;

  svg {
    margin-right: 5px;
  }
`;

export default Container;
